<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
       <b-card class="Reports">
           <div style="display:none"> {{columns}} {{titles}} {{fields}} </div>
           <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
           <form-wizard 
                v-else
                title=""
                subtitle=""
                color="#007bff"
            >
                <template slot="footer" slot-scope="props">
                    <div class="wizard-footer-left">
                        <wizard-button  v-if="props.activeTabIndex > 0" @click.native="props.prevTab()" :style="props.fillButtonStyle"> {{ $t('customer.wizzard.prev') }} </wizard-button>
                    </div>
                    <div class="wizard-footer-right">
                        <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle"> {{ $t('customer.wizzard.next') }} </wizard-button>
                        <wizard-button v-else @click.native="() => exportXlsx() " class="wizard-footer-right finish-button" :style="props.fillButtonStyle">  {{props.isLastStep ? $t('customer.wizzard.complete') : $t('customer.wizzard.next')}}</wizard-button>
                    </div>
                </template>
                <tab-content title="Başlıklar" icon="ti-layout-tab-window " class="formGroup">
                    <p>
                        Esnek Excel Raporlaması ile kendi belirlediğiniz alanların raporunu alabilirsiniz. Aşağıdaki form üzerinden alanlarınızın 
                        başlıklarını belirtebilir ve sırasını belirleyebilirsiniz. Alanların sırasını sürükle bırak ile değiştirebilirsiniz.
                        Başlığını boş bıraktığınız alanlar raporda görüntülenmeyecektir.
                    </p>
                    <b-form class="formBox"> 
                        <draggable style="display: flex; flex-wrap: wrap; justify-content: space-between;" v-model="fields" tag="thead">
                            <div style="margin: 1rem" v-for="(field,i) in fields" :key="field">
                                <strong>{{i+1+'. '+$t('reports.titles.'+columns[field])+' ('+columns[field]+')'}}</strong>
                                <b-input v-model="titles[field]" />
                            </div>
                        </draggable> 
                    </b-form>
                </tab-content>
                <tab-content title="Filtrelemeler" icon="ti-filter" class="formGroup" >
                     <p>
                        Raporlarınızda oluşturulacak verileri istediğiniz gibi filtreleyebilirsiniz. Aşağıdaki seçenekler ile verilerinizi 
                        filtreleyip excel raporu şeklinde indirebilirsiniz.
                    </p>
                      <b-form class="formBox"> 
                            <b-form-group class="inputGrp" label="Tarih Aralığı" label-for="beginDate">
                                <Datetime id="beginDate" v-model="beginDate" />
                                <Datetime id="endDate" v-model="endDate" />
                            </b-form-group>
                            <b-form-radio-group
                                id="active"
                                v-model="state"
                                :options="states"
                                aria-describedby="live-feedback">
                            </b-form-radio-group>
                            <b-form-group class="inputGrp" label="">
                                <div class="elements">
                                    <b-form-checkbox  v-model="allAccounts" >
                                        <span v-if="allAccountType"> Tüm Aboneler </span>
                                        <span v-else> Belirli Aboneler </span>
                                    </b-form-checkbox> 
                                    <Multiselect v-model="selectedAccounts" :show-labels="true" :options="accounts"  :custom-label="customLabel" :multiple="true" v-if="!allAccounts" :taggable="true" label="name" track-by="ID" :searchable="true" @search-change="search" >
                                        <template slot="singleLabel" slot-scope="props">
                                            <strong>{{ props.option.account.account_no+' '+props.option.name }}</strong> 

                                        </template>
                                    </Multiselect>
                                
                                </div>
                            </b-form-group>
                            <b-form-group class="inputGrp" label="">
                                <div class="elements">
                                    <b-form-checkbox  v-model="allAccountType" >
                                        <span v-if="allAccountType"> Tüm Abone Tipleri </span>
                                        <span v-else> Belirli Abone Tipleri</span>
                                    </b-form-checkbox> 
                                    <Multiselect v-model="accountType" :show-labels="false" :options="accountTypes" :multiple="false" v-if="!allAccountType" label="name" track-by="id" >
                                        <template slot="singleLabel" slot-scope="{ option }">
                                            <strong>{{ option.name }}</strong> 
                                        </template>
                                    </Multiselect>
                                
                                </div>
                            </b-form-group>
                            <b-form-group class="inputGrp" label="">
                                <div class="elements">
                                    <b-form-checkbox  v-model="allCountry" >
                                        <span v-if="allCountry"> Tüm Ülkedeki Aboneler </span>
                                        <span v-else> Belirli Ülkedeki Aboneler</span>
                                    </b-form-checkbox> 
                                    <Multiselect v-model="country" :show-labels="false" :options="countries" :multiple="false" v-if="!allCountry" label="name" track-by="id" >
                                        <template slot="singleLabel" slot-scope="{ option }">
                                            <strong>{{ option.name }}</strong> 
                                        </template>
                                    </Multiselect>
                                
                                </div>
                            </b-form-group>
                            <b-form-group class="inputGrp" label="">
                                <div class="elements">
                                    <b-form-checkbox  v-model="allCities" >
                                        <span v-if="allCities"> Tüm Şehirlerdeki Aboneler </span>
                                        <span v-else> Belirli Şehirlerdeki Aboneler</span>
                                    </b-form-checkbox> 
                                    <Multiselect v-model="city" :show-labels="false" :options="cities" :multiple="false" v-if="!allCities" label="name" track-by="id" >
                                        <template slot="singleLabel" slot-scope="{ option }">
                                            <strong>{{ option.name }}</strong> 
                                        </template>
                                    </Multiselect>
                                
                                </div>
                            </b-form-group>
                            <b-form-group class="inputGrp" label="">
                                <div class="elements">
                                    <b-form-checkbox  v-model="allTowns" >
                                        <span v-if="allTowns"> Tüm İlçelerdeki Aboneler </span>
                                        <span v-else> Belirli İlçelerdeki Aboneler</span>
                                    </b-form-checkbox> 
                                    <Multiselect v-model="town" :show-labels="false" :options="towns" :multiple="false" v-if="!allTowns" label="name" track-by="id" >
                                        <template slot="singleLabel" slot-scope="{ option }">
                                            <strong>{{ option.name }}</strong> 
                                        </template>
                                    </Multiselect>
                                
                                </div>
                            </b-form-group>
                            <b-form-group class="inputGrp" label="">
                                <div class="elements">
                                    <b-form-checkbox  v-model="allCompany" >
                                        <span v-if="allCompany"> Tüm Firmalar </span>
                                        <span v-else> Belirli Firmalar</span>
                                    </b-form-checkbox> 
                                    <Multiselect v-model="company" :show-labels="false" :options="companies" :multiple="false" v-if="!allCompany" label="name" track-by="id" >
                                        <template slot="singleLabel" slot-scope="{ option }">
                                            <strong>{{ option.name }}</strong> 
                                        </template>
                                    </Multiselect>
                                
                                </div>
                            </b-form-group>

                            <b-form-group class="inputGrp" label="" >
                                <div class="elements">
                                    <b-form-checkbox  v-model="allCommunicate" > 
                                        <span v-if="allCommunicate"> Tüm İletişim Türleri </span>
                                        <span v-else> Belirli İletişim Türleri</span>
                                    </b-form-checkbox> 
                                    <Multiselect  v-model="communicate" :options="communicates" :multiple="false" v-if="!allCommunicate" :show-labels="false" label="name" track-by="id" >
                                        <template slot="singleLabel" slot-scope="{ option }">
                                            <strong>{{ option.text }}</strong> 
                                        </template>
                                    </Multiselect>
                                </div>
                            </b-form-group>

                            <b-form-group class="inputGrp" label="" >
                                <div class="elements">
                                    <b-form-checkbox  v-model="allJob" > 
                                        <span v-if="allJob"> Tüm Meslekler </span>
                                        <span v-else> Belirli Meslekler</span>
                                    </b-form-checkbox> 
                                    <Multiselect  v-model="job" :options="jobs" :multiple="false" v-if="!allJob" :show-labels="false" label="name" track-by="id" >
                                        <template slot="singleLabel" slot-scope="{ option }">
                                            <strong>{{ option.text }}</strong> 
                                        </template>
                                    </Multiselect>
                                </div>
                            </b-form-group>

                            <b-form-group class="inputGrp" label="" >
                                <div class="elements">
                                    <b-form-checkbox  v-model="allBrand" > 
                                        <span v-if="allBrand"> Tüm Paneller </span>
                                        <span v-else> Belirli Paneller</span>
                                    </b-form-checkbox> 
                                    <Multiselect  v-model="brand" :options="brands" :multiple="false" v-if="!allBrand" :show-labels="false" label="name" track-by="id" >
                                        <template slot="singleLabel" slot-scope="{ option }">
                                            <strong>{{ option.text }}</strong> 
                                        </template>
                                    </Multiselect>
                                </div>
                            </b-form-group>

                            <b-form-group class="inputGrp" label="" >
                                <div class="elements">
                                    <b-form-checkbox  v-model="allProtocol" > 
                                        <span v-if="allProtocol"> Tüm Sinyal Protokolleri </span>
                                        <span v-else> Belirli Protokoller</span>
                                    </b-form-checkbox> 
                                    <Multiselect  v-model="protocol" :options="protocols" :multiple="false" v-if="!allProtocol" :show-labels="false" label="name" track-by="id" >
                                        <template slot="singleLabel" slot-scope="{ option }">
                                            <strong>{{ option.text }}</strong> 
                                        </template>
                                    </Multiselect>
                                </div>
                            </b-form-group>
                      </b-form>  
                </tab-content>
               
            </form-wizard>
           
            <template v-slot:footer class="footer">
            </template>
        </b-card>
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import Modals from './modals/'
    import Multiselect from 'vue-multiselect'
    import { Datetime } from 'vue-datetime';
    import i18n from '@/plugins/i18n';
    import moment from 'moment'
    import draggable from 'vuedraggable'

    let breadCrumb = [
        { label: "Raporlar", url: "/Reports" },
        { label: "Esnek Excel Raporu", url: "/Reports/CustomReports" },
    ]

    export default {
        name: 'Reports',
        created: async function(){
            await this.$store.dispatch("getFlexReport",this.$route.params.code)
            await this.$store.dispatch('company_get', {limit: 1000, offset: 0})
            await this.$store.dispatch('getAccounts', this.params)
            await this.$store.dispatch('listAccountType')
            await this.$store.dispatch('listJobs')
            await this.$store.dispatch('listBrands')
            await this.$store.dispatch('signalprotocol_list')
            await this.$store.dispatch('country_list')
        },
        watch:{
            country: function(){
                this.$store.dispatch('listCities', this.country.country_id)
                this.city = null
                this.town = null

            },
            city:function(){
                this.$store.dispatch('listTowns', {city: this.city.city_id, country: 212})
                this.town = null
            },
           
        },
        computed: {
            loading(){
                return this.$store.getters.getReportLoading
            },
            columns(){
                if(this.$store.getters.getColumns.data){
                    if(localStorage.getItem("FlexField"+this.$route.params.code+'Fields')){
                        this.fields = localStorage.getItem("FlexField"+this.$route.params.code+'Fields').split(',')
                    }else{
                        this.fields = Object.keys(this.$store.getters.getColumns.data)
                    }
                    if(localStorage.getItem("FlexField"+this.$route.params.code+'Titles')){
                        this.titles = localStorage.getItem("FlexField"+this.$route.params.code+'Titles').split(',')
                    }else{
                        let tmpTitles = '';
                         Object.values(this.$store.getters.getColumns.data).map(val => {
                             if(tmpTitles !== '')
                               tmpTitles += ','
                             tmpTitles += i18n.t('reports.titles.'+val)
                        })
                        this.titles = tmpTitles.split(',')
                    }
                }
                return this.$store.getters.getColumns.data
            },
            accountTypes(){
                return this.$store.getters.getAccountTypes
            },
            countries(){
                return this.$store.getters.getCountries
            },
            cities(){
                return this.$store.getters.getCities
            },
            towns(){
                return this.$store.getters.getTowns
            },
            companies(){
                return this.$store.getters.getCompanies
            },
            jobs(){
                return this.$store.getters.getJobs
            },
            brands(){
                return this.$store.getters.getBrands
            },
            protocols(){
                return this.$store.getters.getProtocols
            },
            accounts(){
                return this.$store.getters.getAccounts
            },
        },
        data:function(){
            return{
                breadCrumb,
                beginDate: moment().subtract(1, 'months').format('YYYY-MM-DDTHH:mm:ssZ'),
                endDate: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
                state: 2,
                accountType: null,
                city: null,
                town: null,
                country: null,
                company: null,
                job: null,
                selectedAccounts: [],
                communicate: null,
                brand: null,
                protocol: null,
                allAccountType: true,
                allAccounts: true,
                allCountry: true,
                allCities: true,
                allTowns: true,
                allCompany: true,
                allCommunicate: true,
                allJob: true,
                allBrand: true,
                allProtocol: true,
                fields: [],
                titles: [],
                params:{
                    limit:20,
                    offset: 0,
                },
                states: [
                    { text: 'Aktif Aboneler', value: 2 },
                    { text: 'Pasif Aboneler', value: 1 },
                    { text: 'İptal Aboneler', value: 3 }
                ],
                communicates: [
                    {id: 0, name:  i18n.t('account.com.gprs')},
                    {id: 1, name:  i18n.t('account.com.pstn')},
                    {id: 2, name:  i18n.t('account.com.ethernet')},
                ],
                
            }
        },
        components:{
            BreadCrumb, Modals, Multiselect, Datetime, draggable
        },
        methods:{
            customLabel (acc) {
                return `${acc.account_info.account.account_no} – ${acc.name}`
            },
            search(s){
                this.params['name'] = s
                this.$store.dispatch('getAccounts', this.params)
            },
            exportXlsx: async function(){
                let data = {
                    "begin-date": this.beginDate,
                    "com-type": !this.allCommunicate ? this.communicate : null ,
                    "company": !this.allCompany ? this.company : null,
                    "account-type": !this.allAccountType ? this.accountType : null,
                    "city": !this.allCountry ? !allCities ? this.city.city_id : null : null,
                    "town": !this.allCountry ? !allCities ? !allTowns ? this.city.city_id : null : null : null,
                    "job": !this.allJob ? this.job : null,
                    "panel-brand": !this.allBrand ? this.brand : null,
                    "protocol": !this.allProtocol ? this.protocol : null,
                    "is-active": this.state,
                    "end-date": this.endDate,
                    responseType: 'arraybuffer'
                }
                if(!this.allAccounts){
                    let selectedAcc = this.selectedAccounts.map(item => {
                        return item.ID
                    })
                    data['account-nos'] = selectedAcc.join()

                }
                let selectedColumns = this.fields.map(item => {
                    return this.$store.getters.getColumns.data[item] + ':' + this.titles[item]
                })
                data.columns = selectedColumns.join()
                localStorage.setItem("FlexField"+this.$route.params.code+'Fields', this.fields)
                localStorage.setItem("FlexField"+this.$route.params.code+'Titles', this.titles)

                await this.$store.dispatch('downloadFlexReport', {data: data, code: this.$route.params.code })
                if(this.$store.getters.flexReport){
                    let url = window.URL.createObjectURL(new Blob([this.$store.getters.flexReport]))
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', moment(this.beginDate).format('DD.MM.YYYY')+'-'+moment(this.endDate).format('DD.MM.YYYY')+' EsnekRapor.xlsx');
                    document.body.appendChild(link);
                    link.click();
                }else{
                    this.$bvToast.toast('Rapor Oluşturulamadı. Filtrelemelerinizin doğru olduğundan emin olun lütfen', {
                        title: `Başarılı! `,
                        variant: 'danger',
                        solid: true
                    })
                }
                
            },
        }
    }
</script>

<style lang="css" scoped> 
    @import "./styles/report.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Reports/CustomExcel.vue